export default "__VITE_ASSET__CqJGHeUa__"